<template>
  <div >
    <div class="originText">
      <iframe :src="pdfUrl" width="100%" class="iframeBox" ></iframe>
    </div>

  </div>
</template>

<script>
import { fillPublicPath } from '@/filters'
// import { getPics } from '@/api/classification'

export default {
  props: {
    fileList: Object
  },
  data() {
    return {
      pdfUrl: ''
    }
  },
  computed: {

  },
  watch: {
    fileList: {
      deep: true,
      handler() {
        this.getPdfUrl()
      }
    }
  },
  mounted() {
    this.getPdfUrl()
  },
  methods: {
    getPdfUrl() {
      const path = this.fileList.pdfFile[0].filePath
      const urlPath = fillPublicPath('/static/pdf/web/viewer.html')
      const urlCode = encodeURIComponent(path)
      this.pdfUrl = `${urlPath}?file=${urlCode}`
    }
  }

}
</script>
